import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollAdjustmentHistory extends Layout {
    checkboxExcludeTaxDeductions: Checkbox;
    checkboxIncludeSettlement: Checkbox;
    excludabletextboxGLAccount: ExcludableTextbox;
    excludabletextboxPayAdjustmentCodes: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceOfficePayrollAdjustmentHistory: DataSource;
    switchReportType: Switch;
    textboxCheckDateRange: Textbox;
    textboxGroupBy: Textbox;
    textboxPayeeType: Textbox;
}
